export function InputField({
  id,
  name,
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  required,
  icon
}) {
  return (
    <div className="space-y-2">
      <label
        htmlFor={id}
        className="block font-semibold text-[#1d7270] mb-1"
      >
        {label}
      </label>

      <div className="flex items-center gap-3">
        {/* Icon outside the box */}
        {icon && <span className="text-gray-500">{icon}</span>}

        {/* Input */}
        <input
          id={id}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          placeholder={placeholder}
          className="flex-1 block w-full px-3 py-3 border border-gray-300 rounded-lg 
            focus:ring-2 focus:ring-[#1d7270] focus:border-[#1d7270] 
            text-gray-900 placeholder-gray-300"
        />
      </div>
    </div>
  );
}
